import React, { useEffect, useState } from 'react';
import Flatpickr from 'react-flatpickr';
import { Label, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import ActionButton from '../../../../../../Components/Common/ActionButton';
import {
  FormGrid,
  RequiredNote,
  TextAreaField,
  focusFirstError,
  hasErrors,
  required,
  validateForm,
} from '../../../../../../Components/Form';
import {
  formatForAPI,
  formatForFlatpickr,
} from '../../../../../../utils/dateformatpickr';

const EMPTY_FORM = {
  closingDateImprovement: '',
  message: '',
};

const VALIDATION = {
  closingDateImprovement: {
    label: 'Closing date improvement',
    rules: [required()],
  },
  message: { label: 'Message', rules: [required()] },
};
const FIELD_ORDER = ['closingDateImprovement', 'message'];

const CLOSING_DATE_OPTIONS = {
  enableTime: true,
  dateFormat: 'd/m/Y H:i',
  time_24hr: true,
};

const RequestImprovementModal = ({
  isOpen,
  onClose,
  onSubmit,
  isSubmitting = false,
  selectedCount = 0,
}) => {
  const [form, setForm] = useState(EMPTY_FORM);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (!isOpen) {
      setForm(EMPTY_FORM);
      setErrors({});
    }
  }, [isOpen]);

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
    setErrors(prev => ({ ...prev, [name]: undefined }));
  };

  const validate = () => {
    const nextErrors = validateForm(form, VALIDATION);
    setErrors(nextErrors);
    if (hasErrors(nextErrors)) focusFirstError(nextErrors, FIELD_ORDER);
    return !hasErrors(nextErrors);
  };

  const handleSubmit = () => {
    if (!validate()) return;
    onSubmit?.({
      ...form,
      closingDateImprovement:
        formatForAPI(form.closingDateImprovement) ||
        form.closingDateImprovement,
    });
  };

  return (
    <Modal isOpen={isOpen} toggle={onClose} centered backdrop='static'>
      <ModalHeader toggle={onClose}>
        Send Request Improvement
        {selectedCount > 0 ? (
          <span className='text-muted fs-13 fw-normal ms-2'>
            ({selectedCount} offer selected)
          </span>
        ) : null}
      </ModalHeader>
      <ModalBody>
        <RequiredNote />
        <FormGrid columns={1}>
          <div className='mb-2'>
            <Label
              for='closingDateImprovement'
              className='form-label fw-semibold'
            >
              Closing date improvement (Jakarta Local Time)
              <span className='text-danger ms-1'>*</span>
            </Label>
            <Flatpickr
              id='closingDateImprovement'
              name='closingDateImprovement'
              className={`form-control${
                errors.closingDateImprovement ? ' is-invalid' : ''
              }`}
              options={CLOSING_DATE_OPTIONS}
              value={formatForFlatpickr(form.closingDateImprovement) || ''}
              disabled={isSubmitting}
              onChange={selectedDates => {
                setForm(prev => ({
                  ...prev,
                  closingDateImprovement: selectedDates[0] || '',
                }));
                setErrors(prev => ({
                  ...prev,
                  closingDateImprovement: undefined,
                }));
              }}
            />
            {errors.closingDateImprovement ? (
              <div className='text-danger d-flex align-items-center gap-1 mt-1'>
                <i className='ri-error-warning-line' aria-hidden='true' />
                <span>{errors.closingDateImprovement}</span>
              </div>
            ) : null}
          </div>
          <TextAreaField
            label='Message'
            name='message'
            rows={4}
            required
            value={form.message}
            onChange={handleChange}
            disabled={isSubmitting}
            error={errors.message}
          />
        </FormGrid>
      </ModalBody>
      <ModalFooter>
        <ActionButton
          variant='secondary'
          icon='ri-close-line'
          onClick={onClose}
          disabled={isSubmitting}
        >
          Close
        </ActionButton>
        <ActionButton
          variant='primary'
          icon='ri-send-plane-line'
          onClick={handleSubmit}
          loading={isSubmitting}
        >
          Submit
        </ActionButton>
      </ModalFooter>
    </Modal>
  );
};

export default RequestImprovementModal;
